/* eslint-disable react/jsx-curly-brace-presence */

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'

const styles = theme => ({
  root: {
    padding: '20px 15px 15px',
    backgroundColor: `var(--gameday-body-background, ${theme.body.background})`,
    '& h2': {
      fontSize: '19px',
    },
  },
  contentStyle: {
    padding: '15px',
  },
})

class AlertDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    const { isOpen } = nextProps
    if (isOpen !== this.props.isOpen) {
      this.setState({ isOpen })
    }
  }

  handleClickOpen = () => {
    this.setState({ isOpen: true })
  }

  handleClose = action => {
    const { handleSaveCancel, isClose } = this.props
    if (isClose) {
      isClose()
    }
    handleSaveCancel(action)
    this.setState({ isOpen: false })
  }

  render() {
    const { classes, children, value } = this.props
    return (
      <div>
        <Dialog
          open={this.state.isOpen}
          onClose={() => {
            this.handleClose('cancel')
          }}
          disableBackdropClick
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle className={classes.root} id="alert-dialog-title">
            {'Alert!!!'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" className={classes.contentStyle}>
              {value}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.contentStyle}>
            {children || (
              <div>
                <Button
                  onClick={() => {
                    this.handleClose('cancel')
                  }}
                  color="primary"
                  aria-label="Cancel"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    this.handleClose('save')
                  }}
                  color="primary"
                  autoFocus
                  aria-label="Save"
                >
                  Save
                </Button>
              </div>
            )}
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

AlertDialog.defaultProps = {
  value: 'Would you like to save the results you have entered before leaving?',
}

export default withStyles(styles)(AlertDialog)
